import { WheatOff, Wheat, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const PHOTOS = [
  {
    id: "croc-1",
    img: "/brand/croc-sandwich-1.webp",
    alt: "Bocadillo CROC LAB en la mano en una calle de Valencia: pan artesano crujiente y relleno muy generoso",
  },
  {
    id: "croc-2",
    img: "/brand/croc-sandwich-2.webp",
    alt: "Bocadillo CROC LAB con rúcula, queso y pan de miga abierta sobre piedra mediterránea",
  },
  {
    id: "croc-3",
    img: "/brand/croc-sandwich-3.webp",
    alt: "Bocadillo CROC LAB con verduras, queso y pan crujiente en una calle mediterránea",
  },
  {
    id: "croc-4",
    img: "/brand/croc-sandwich-4.webp",
    alt: "Bocadillos CROC LAB apilados con rellenos generosos y queso cremoso en una terraza mediterránea",
  },
];

const BREADS = [
  { label: "Clásico", id: "clasico" },
  { label: "Grano duro", id: "grano-duro" },
  { label: "Multicereales", id: "multicereales" },
  { label: "Sin gluten", id: "sin-gluten" },
];

const Producto = () => (
  <section id="producto" data-testid="producto-section" className="py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">El producto</p>
        <h2 className="mt-3 font-display font-bold tracking-tight text-brand-charcoal text-3xl md:text-4xl lg:text-5xl">
          ASÍ SUENA <span className="text-brand-pink">CROC.</span>
        </h2>
        <p className="mt-4 text-base md:text-lg text-brand-charcoal/75 leading-relaxed">
          Pan crujiente. Rellenos generosos. Cero aburrimiento.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-8">
        <div
          data-testid="producto-sin-gluten-badge"
          className="inline-flex flex-col sm:flex-row sm:items-center gap-3 bg-brand-charcoal text-white rounded-3xl px-6 py-5"
        >
          <span className="inline-flex items-center gap-2 bg-brand-pink text-white font-display font-semibold uppercase tracking-wide text-sm md:text-base rounded-full px-5 py-2.5">
            <WheatOff className="w-5 h-5" aria-hidden="true" />
            Sin gluten disponible
          </span>
          <span className="text-sm md:text-base text-white/75">
            Pregunta por nuestras opciones sin gluten.
          </span>
        </div>
      </Reveal>

      <div className="mt-12">
        <Reveal>
          <figure
            data-testid={`producto-card-${PHOTOS[0].id}`}
            className="bg-white rounded-3xl border border-brand-charcoal/10 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300"
          >
            <img
              src={PHOTOS[0].img}
              alt={PHOTOS[0].alt}
              data-testid={`producto-image-${PHOTOS[0].id}`}
              className="w-full h-auto block"
              loading="eager"
            />
          </figure>
        </Reveal>
        <div className="mt-6 md:mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {PHOTOS.slice(1).map((photo, i) => (
            <Reveal key={photo.id} delay={i * 0.06}>
              <figure
                data-testid={`producto-card-${photo.id}`}
                className="bg-white rounded-3xl border border-brand-charcoal/10 shadow-sm overflow-hidden hover:shadow-md hover:-translate-y-1 transition-all duration-300"
              >
                <img
                  src={photo.img}
                  alt={photo.alt}
                  data-testid={`producto-image-${photo.id}`}
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </figure>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.1} className="mt-10">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-charcoal/50">
          Nuestros panes
        </p>
        <ul className="mt-4 flex flex-wrap gap-3">
          {BREADS.map((bread) => (
            <li
              key={bread.id}
              data-testid={`producto-bread-chip-${bread.id}`}
              className={
                bread.id === "sin-gluten"
                  ? "inline-flex items-center gap-2 text-sm font-semibold text-brand-pink bg-brand-pink/10 border border-brand-pink/30 rounded-full px-4 py-2"
                  : "inline-flex items-center gap-2 text-sm font-semibold text-brand-charcoal bg-white border border-brand-charcoal/10 rounded-full px-4 py-2"
              }
            >
              {bread.id === "sin-gluten" ? (
                <WheatOff className="w-4 h-4" aria-hidden="true" />
              ) : (
                <Wheat className="w-4 h-4 text-brand-pink" aria-hidden="true" />
              )}
              {bread.label}
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-8 text-xs md:text-sm text-brand-charcoal/50">
          Fotografías de referencia del producto. Carta final, nombres y precios: próximamente.
        </p>
        <a
          data-testid="producto-alergenos-link"
          href="/alergenos"
          className="mt-4 inline-flex items-center gap-2 text-sm text-brand-charcoal/60 hover:text-brand-pink transition-colors"
        >
          <span className="font-semibold uppercase tracking-wide">¿Alergias o intolerancias?</span>
          <span className="underline underline-offset-2">
            Consulta nuestra información sobre alérgenos
          </span>
          <ArrowRight className="w-4 h-4" aria-hidden="true" />
        </a>
      </Reveal>
    </div>
  </section>
);

export default Producto;
